import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    countryList: ["US"],
    currentCompany: "FH",
    currentAgency: {
      id: null,
      aoId: null,
      name: null,
      address1: null,
      address2: null,
      city: null,
      state: null,
      zip: null,
      country: null,
      phone: null,
      phoneExt: null,
      email: null,
    },
    currentAO: {
      id: null,
      ao: null,
    },
    currentUser: {
      agentNum: null,
      name: null,
    },
    // user: {},
    AOs: [],
    userRoles: "",
    session: "",
    signInTime: null,
    agencyChanges: [],
    tmkClientId: null,
    jwt: null,
    accessCode: null,
    unlockMsg:{ },
    broadcastUnlock: false,
    unlockedHiers: []
  },
  getters: {
    jwt: (state) => {
      let j = window.sessionStorage.getItem("jwt");
      if (!j || j == "") j = state.jwt;

      return j;
    },
    accessCode: (state) => {
      let ac = window.sessionStorage.getItem("accessCode");
      if (!ac || ac == "") ac = state.accessCode;
      return ac;
    },
    tmkClientId: (state) => {
      let tc = window.sessionStorage.getItem("tmkClientId");
      if (!tc || tc == "") tc = state.tmkClientId;
      return tc;
    },
    currentUser: (state) => {
      let user = window.sessionStorage.getItem("currentUser");
      if (user && user != "") {
        try {
          let currentUser = JSON.parse(user);
          return currentUser;
        } catch {
          return state.currentUser;
        }
      }

      return state.currentUser;
    },
  },
  mutations: {
    setUnlockedHier(state, hier){

      if (hier == null)
        state.unlockedHiers = [];
      else
        state.unlockedHiers.push(hier);

    },
    setBroadcastUnlock(state, broadcastUnlock){
      state.broadcastUnlock = broadcastUnlock;
    },
    setUnlockMsg(state, unlockMsg){
      state.unlockMsg = unlockMsg;
    },
    setAccessCode(state, code) {
      state.accessCode = code;
      if (!code) window.sessionStorage.removeItem("accessCode");
      else window.sessionStorage.setItem("accessCode", code);
    },
    setJWT(state, token) {
      state.jwt = token;
      if (!token) window.sessionStorage.removeItem("jwt");
      else window.sessionStorage.setItem("jwt", token);
    },
    setTmkClientId(state, id) {
      state.tmkClientId = id;

      if (!id) window.sessionStorage.removeItem("tmkClientId");
      else window.sessionStorage.setItem("tmkClientId", id);
    },
    setAgencyChanges(state, changes) {
      state.agencyChanges = [];
      state.agencyChanges.push(...changes);
    },
    setSignInTime(state, time) {
      state.signInTime = time;
    },
    setAO(state, AO) {
      state.currentAO = AO;
    },
    setRole(state, roleName) {
      state.role = roleName;
    },
    setAgency(state, agency) {
      state.currentAgency = agency;
    },
    // setUser(state, user) {
    //   state.user = user;
    // },
    // setUserToken(state, tok){
    //   if (state.user && state.user.storage && state.user.keyPrefix && state.user.username
    //     && state.user.storage[state.user.keyPrefix + "." + state.user.username + "." + "accessToken"])
    //    state.user.storage[state.user.keyPrefix + "." + state.user.username + "." + "accessToken"] = tok;
    // },
    setCurrentUser(state, currentUser) {
      state.currentUser = currentUser;

      if (!currentUser) {
        window.sessionStorage.removeItem("currentUser");
      } else
        window.sessionStorage.setItem(
          "currentUser",
          JSON.stringify(currentUser)
        );
    },
    setAOArray(state, AOArray) {
      state.AOs = [];
      state.AOs.push(...AOArray);
    },
    setUserRoles(state, role) {
      if (role) state.userRoles = role;
      else state.userRoles = "";
    },
    setSession(state, pseudoSession) {
      state.session = pseudoSession;
    },
  },
  actions: {},
});
